var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6027\u522B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5B8C\\u5584\\u4FE1\\u606F\\u9875",
    transform: "translate(-51, -744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6027\\u522B",
    transform: "translate(51, 744)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(2, 3)",
    fill: "#111111",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2198029,10.2102803 L21.2198029,3.81542056 L23.7968848,6.34112147 L25.3321677,4.83644858 L20.7263191,0.322429917 C20.2876668,-0.10747661 19.6296884,-0.10747661 19.1910362,0.322429917 L14.5851875,4.83644858 L16.1204704,6.34112147 L18.9717101,3.54672897 L18.9717101,10.156542 C15.7914812,10.6401869 13.3788938,13.2733644 13.3788938,16.5514018 C13.3788938,20.0981307 16.3397965,23 19.9586776,23 C23.5775587,23 26.5384615,20.0981308 26.5384615,16.5514018 C26.5384615,13.3808411 24.2355371,10.8014018 21.2198029,10.2102803 Z M19.9586776,20.8504672 C17.5460902,20.8504672 15.5721551,18.9158878 15.5721551,16.5514018 C15.5721551,14.1869158 17.5460902,12.2523364 19.9586776,12.2523364 C22.371265,12.2523364 24.3452002,14.1869158 24.3452002,16.5514018 C24.3452002,18.9158878 22.3712651,20.8504672 19.9586776,20.8504672 Z M13.1595677,6.44859811 C13.1595677,2.90186917 10.1986649,0 6.57978385,0 C2.96090275,0 0,2.90186914 0,6.44859811 C0,9.56542053 2.30292434,12.1985981 5.37349013,12.7897196 L5.37349013,15.8528037 L1.15146217,15.8528037 L1.15146217,18.0023364 L5.37349013,18.0023364 L5.37349013,21.9252335 L7.5667514,21.9252335 L7.5667514,18.0023364 L12.062937,18.0023364 L12.062937,15.8528037 L7.5667514,15.8528037 L7.5667514,12.8434579 C10.6921487,12.359813 13.1595677,9.67289717 13.1595677,6.44859811 Z M2.19326127,6.44859811 C2.19326127,4.08411214 4.16719641,2.14953269 6.57978385,2.14953269 C8.99237128,2.14953269 10.9663064,4.08411211 10.9663064,6.44859811 C10.9663064,8.81308411 8.99237125,10.7476635 6.57978385,10.7476635 C4.16719644,10.7476635 2.19326127,8.81308408 2.19326127,6.44859811 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSex);
export default __webpack_public_path__ + "static/media/sex.e4c5297325c46981987434f5ec456675.svg";
export { ForwardRef as ReactComponent };